exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textAreaHtml {\n  height: 360px;\n  width: 100%; }\n\n.textBarHtml {\n  background-color: #e8e8e8;\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/adri9/Escritorio/admin-everpath/src/app/componentes/weditorMensajes/weditorMensajes.component.scss
// module id = ../../../../../src/app/componentes/weditorMensajes/weditorMensajes.component.scss
// module chunks = main